module.exports = __webpack_public_path__ + "img/hush.e60dd53f.svg";